export default __webpack_public_path__ + "static/media/T35.cf798fe0.JPG";